




















import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class FAQ extends Vue {
  private faqs = ["savedData", "howLong", "validity", "print"];
}
